import $ from "jquery";
import App from "./src/App";
import gsap from "gsap";
import "./components/Marquee";
import "./components/ContactForm7";
import "bootstrap/js/dist/alert";

import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Header Menu Animation
const menuTL = gsap.timeline({ paused: true, ease: "power2.out" });

menuTL.to(".js-navigation", { height: "100vh", opacity: 1, visibility: "visible" });

$(".js-open-menu").click(function () {
  menuTL.duration(0.3).play();
  $("body").addClass("menu-open");
});

$(".js-close-menu").click(function () {
  menuTL.duration(0.3).reverse();
  $("body").removeClass("menu-open");
});

// General Fade
$(".js-general-fade").each(function () {
  const generalFadeTL = gsap.timeline({
    scrollTrigger: {
      trigger: $(this),
      start: "top 90%",
    },
  });
  generalFadeTL.from($(this), { y: 100, opacity: 0, duration: 0.7 });
});

// Text fade
$(".js-text-fade").each(function () {
  const textTL = gsap.timeline({
    scrollTrigger: {
      trigger: $(this),
      start: "top 90%",
    },
  });
  textTL.from($(this), { y: 50, opacity: 0, duration: 0.7 });
});

$(document).ready(function () {
  let scrollThreshold = 50;

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > scrollThreshold) {
      $(".header__wrapper").addClass("scrolled");
    } else {
      $(".header__wrapper").removeClass("scrolled");
    }
  });
});

$(document).ready(function () {
  if (sessionStorage.getItem("formSubmitted")) {
    const newsletterForm = $(".site-footer__newsletter");
    if (newsletterForm.length) {
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: newsletterForm.offset().top,
          },
          100,
        );
      });
    }
    sessionStorage.removeItem("formSubmitted");
  }

  const formContainer = $(".footer-newsletter__form").closest("form");
  if (formContainer.length) {
    formContainer.on("submit", function () {
      sessionStorage.setItem("formSubmitted", "true");
    });
  }
});

$(".cookie-policy-toggle").click((e) => {
  e.preventDefault();
  revisitCkyConsent();
});
